import React from 'react';
import { Link } from 'react-router-dom';

class MainBanner extends React.Component {
    render(){
        return (
            <div className="page-title-area item-bg1">
                <div className="container">
                    <h1>Competition</h1>
                    <span>More Info About the Competitions</span>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li>Competition</li>
                    </ul>
                </div>
            </div>
        );
    }
}
 
export default MainBanner;